"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationClickHandlerSymbol = exports.SiteLinkClickHandlerSymbol = exports.LinkClickHandlerSymbol = void 0;
exports.LinkClickHandlerSymbol = Symbol('LinkClickHandler');
exports.SiteLinkClickHandlerSymbol = Symbol('SiteLinkClickHandlerSymbol');
exports.NavigationClickHandlerSymbol = Symbol('NavigationClickHandlerSymbol');
//# sourceMappingURL=clickHandlerRegistrar.js.map